
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[encodedName]",
      function () {
        return require("private-next-pages/companies/[encodedName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[encodedName]"])
      });
    }
  